import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Button from './Button';
import { StopSign } from './icons';

const StagingBanner = () => {
  const [environment, setEnvironment] = useState('');
  useEffect(() => {
    const GetData = async () => {
      const { data } = await axios.get('/api/utility/GetEnvironment');
      if (data.toLowerCase() !== 'production') {
        setEnvironment(data);
      }
    };
    GetData();
  }, []);

  return (
    <div>
      {environment && (
        <div
          style={{
            position: 'relative',
            backgroundColor: '#FFF5F5',
            color: '#FF5252',
            // display: 'flex',
            alignItems: 'center',
            border: '1.35px solid #FFE6E6',
            borderRadius: 5,
            height: 72,
            marginLeft: 31,
            marginRight: 28,
            top: 27,
            display: 'none',
          }}
        >
          <div style={{ padding: 16 }}>
            <StopSign />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ fontSize: 16, marginBottom: 4 }}>{environment.toUpperCase()} Client Portal</div>
            <a href="https://www.hudsonsearch.com" target="_blank">
              <div
                style={{
                  height: 28,
                  width: 165,
                  backgroundColor: '#ff5252',
                  color: 'white',
                  borderRadius: 5,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                Go back to Production
              </div>
            </a>
          </div>
        </div>
      )}
    </div>
  );
};
export default StagingBanner;
